"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YEESITE_24W = exports.SLIM_PAR_38 = exports.LIGHT_STYLE_IDS = exports.LALUCE_NATZ_18LED = exports.COB_50W = exports.CHAUVET_COLORSTRIP_MINI = void 0;
exports.getLightStyle = getLightStyle;
const SLIM_PAR_38 = exports.SLIM_PAR_38 = 'SLIM_PAR_38';
const YEESITE_24W = exports.YEESITE_24W = 'YEESITE_24W';
const LALUCE_NATZ_18LED = exports.LALUCE_NATZ_18LED = 'LALUCE_NATZ_18LED';
const CHAUVET_COLORSTRIP_MINI = exports.CHAUVET_COLORSTRIP_MINI = 'CHAUVET_COLORSTRIP_MINI';
const COB_50W = exports.COB_50W = 'COB_50W';
const LIGHT_STYLE_IDS = exports.LIGHT_STYLE_IDS = {
  NONE: 'NONE',
  NO_CHANGE: 'NO_CHANGE',
  // AMBIANCE
  AMBIANCE_BLUE: 'AMBIANCE_BLUE',
  AMBIANCE_BLUE_STEALTH: 'AMBIANCE_BLUE_STEALTH',
  AMBIANCE_RED: 'AMBIANCE_RED',
  AMBIANCE_WHITE: 'AMBIANCE_WHITE',
  // COLOR
  RED: 'RED',
  RED_LOW: 'RED_LOW',
  GREEN: 'GREEN',
  GREEN_LOW: 'GREEN_LOW',
  BLUE: 'BLUE',
  BLUE_LOW: 'BLUE_LOW',
  INFINID_ORANGE: 'INFINID_ORANGE',
  WHITE: 'WHITE',
  PASSIVE_RED: 'PASSIVE_RED',
  // ADDING COLOR
  ADD_RED: 'ADD_RED',
  ADD_GREEN: 'ADD_GREEN',
  ADD_BLUE: 'ADD_BLUE',
  // SUBTRACTING COLORS
  SUB_RED: 'SUB_RED',
  SUB_GREEN: 'SUB_GREEN',
  SUB_BLUE: 'SUB_BLUE',
  // EFFECTS
  PULSE: 'PULSE',
  PULSE_MEDIUM: 'PULSE_MEDIUM',
  PULSE_FAST: 'PULSE_FAST',
  FADE_IN: 'FADE_IN',
  FADE_IN_SLOW: 'FADE_IN_SLOW',
  FADE_IN_MEDIUM: 'FADE_IN_MEDIUM',
  FADE_IN_FAST: 'FADE_IN_FAST',
  FADE_OUT_SLOW: 'FADE_OUT_SLOW',
  FADE_OUT: 'FADE_OUT',
  FADE_OUT_MEDIUM: 'FADE_OUT_MEDIUM',
  FADE_OUT_FAST: 'FADE_OUT_FAST',
  NO_EFFECT: 'NO_EFFECT',
  NO_EFFECT_LOW: 'NO_EFFECT_LOW',
  NO_EFFECT_VERY_LOW: 'NO_EFFECT_VERY_LOW',
  // BRIGHTNESS
  BRIGHTNESS_HIGH: 'BRIGHTNESS_HIGH',
  BRIGHTNESS_BLIP: 'BRIGHTNESS_BLIP',
  BRIGHTNESS_MEDIUM: 'BRIGHTNESS_MEDIUM',
  BRIGHTNESS_LOW: 'BRIGHTNESS_LOW',
  BRIGHTNESS_VERY_LOW: 'BRIGHTNESS_VERY_LOW',
  // NEXT LEVEL!
  DANCE_PARTY: 'DANCE_PARTY'
};

/**
 * Documentation for each light:
 * SLIM PAR 38:       https://www.chauvetdj.com/wp-content/uploads/2015/12/SlimPAR_38_UM_Rev4_WO-1.pdf
 * YEESITE 24W:       https://images-na.ssl-images-amazon.com/images/I/A18KN79-U8L.pdf
 * COB 50W:           https://images-na.ssl-images-amazon.com/images/I/B13yXKS26wS.pdf
 * LALUCE NATZ 18LED: https://images-na.ssl-images-amazon.com/images/I/B1vDZm6YD0S.pdf
 */

// effect types
const LEAVE_EFFECT = 'LEAVE_EFFECT';
const PULSE = 'PULSE';
const FADE_IN = 'FADE_IN';
const FADE_OUT = 'FADE_OUT';
const NO_EFFECT = 'NO_EFFECT';
const DANCE_PARTY = 'DANCE_PARTY';
const FAST_EFFECT = 250;
const DEFAULT_CHANNEL_OPTIONS = {
  red: 0,
  green: 0,
  blue: 0,
  brightness: 255
};
const DEFAULT_PASSIVE_CHANNEL_OPTIONS = {
  red: -1,
  green: -1,
  blue: -1,
  brightness: -1
};
/**
 * Gets the channels for each type of light. This function gets the values to set the light specifically for the given
 * combination of options and effects, using `0` for any channels that don't need to be set. This is in contrast with the
 * `getPassiveChannels` function, which will try to leave the state of the light as untouched as possible but tries to
 * leave the state of the light as unaltered as possible.
 *
 * Example: If the light is currently pulsing and red, and you want to turn the light blue, the channels returned from this function will
 * make the light blue and no longer pulsing.
 *
 * @param {ChannelOptions} options  values for any of red, blue, green, or brightness
 * @param {?Effect[]} effects Any special types of effects to include
 */
function getChannels(options, effects = []) {
  const {
    speed,
    ...otherOptions
  } = options || {};
  const {
    red,
    green,
    blue,
    brightness
  } = {
    ...DEFAULT_CHANNEL_OPTIONS,
    ...otherOptions
  };
  const {
    slimParMacro,
    slimParSpeed,
    slimParMode,
    yeesiteStrobeSpeed,
    yeesiteMode,
    laluceHoppingMode,
    laluceSpeed,
    laluceMode,
    whiteChannel,
    chauvetMode,
    cobStrobeSpeed,
    cobMode,
    cobSpeed,
    amberChannel
  } = getSpecializedChannelValues({
    effects,
    speed
  });
  return {
    [SLIM_PAR_38]: [red, green, blue, slimParMacro, slimParSpeed, slimParMode, brightness],
    [YEESITE_24W]: [brightness, red, green, blue, whiteChannel, yeesiteStrobeSpeed, yeesiteMode],
    [LALUCE_NATZ_18LED]: [brightness, red, green, blue, laluceHoppingMode, laluceSpeed, laluceMode],
    [CHAUVET_COLORSTRIP_MINI]: [chauvetMode, red, green, blue],
    [COB_50W]: [brightness, red, green, blue, whiteChannel, amberChannel, cobStrobeSpeed, cobMode, cobSpeed]
  };
}

/**
 * Gets the *passive* channels for each type of light. This function gets the values to set the light for the given
 * combination of options and effects, using `-1` for any channels that don't need to be set, which will leave the light state
 * as unaltered as possible. This is in contrast with the `getChannels` function, which will try to update the whole light state
 * to only be the combination of options passed in.
 *
 * Example: If the light is currently pulsing and red, and you want to turn the light blue, the channels returned from this function will
 * make the light pulsing and blue.
 *
 * @param {ChannelOptions} options  values for any of red, blue, green, or brightness
 * @param {?Effect[]} effects Any special types of effects to include
 */
function getPassiveChannels(options, effects = []) {
  const {
    speed,
    ...otherOptions
  } = options || {};
  const {
    red,
    green,
    blue,
    brightness
  } = {
    ...DEFAULT_PASSIVE_CHANNEL_OPTIONS,
    ...otherOptions
  };
  const {
    slimParMacro,
    slimParSpeed,
    slimParMode,
    yeesiteStrobeSpeed,
    yeesiteMode,
    laluceHoppingMode,
    laluceSpeed,
    laluceMode,
    whiteChannel,
    chauvetMode,
    amberChannel,
    cobStrobeSpeed,
    cobMode,
    cobSpeed
  } = getSpecializedChannelValues({
    effects,
    speed,
    passive: true
  });
  return {
    [SLIM_PAR_38]: [red, green, blue, slimParMacro, slimParSpeed, slimParMode, brightness],
    [YEESITE_24W]: [brightness, red, green, blue, whiteChannel, yeesiteStrobeSpeed, yeesiteMode],
    [LALUCE_NATZ_18LED]: [brightness, red, green, blue, laluceHoppingMode, laluceSpeed, laluceMode],
    [CHAUVET_COLORSTRIP_MINI]: [chauvetMode, red, green, blue],
    [COB_50W]: [brightness, red, green, blue, whiteChannel, amberChannel, cobStrobeSpeed, cobMode, cobSpeed]
  };
}

/**
 * Different light types use different values for special effects such as pulse, fade in/out, etc.
 * Given a list of effects to apply to the lights (PULSE, LEAVE_EFFECT, etc), this function gets
 * the correct values for all of the different lights, returned as an object of type `SpecializedChannelValues`
 */
function getSpecializedChannelValues({
  effects,
  passive,
  speed
}) {
  let slimParSpeed = passive ? -1 : 0;
  let slimParMode = passive ? -1 : 0;
  let yeesiteStrobeSpeed = passive ? -1 : 0;
  let yeesiteMode = passive ? -1 : 0;
  let laluceMode = passive ? -1 : 0;
  let laluceSpeed = passive ? -1 : 0;
  let cobMode = passive ? -1 : 0;
  let cobSpeed = passive ? -1 : 0;
  effects.forEach(effect => {
    switch (effect) {
      case PULSE:
        {
          slimParMode = 96;
          slimParSpeed = speed || 0;

          // Yeesite has a "Fade Mode" ([100-149]) and a "Pulse Mode" ([150-200]) but I
          // could only get them to change colors, never stay on the same color
          yeesiteMode = 0;
          yeesiteStrobeSpeed = 0;

          // Laluce has "Fade Mode", which fades between colors, and is NOT the pulse effect
          laluceMode = 0;
          laluceSpeed = 0;

          // Cob has "Fade Mode" ([101-150]) and "Pulse Mode" ([151-200]), but these only
          // seem to fade and pulse *between colors*
          cobMode = 0;
          cobSpeed = 0;
          break;
        }
      case FADE_IN:
        {
          slimParMode = 63;
          slimParSpeed = speed || 0;
          yeesiteMode = 100;
          yeesiteStrobeSpeed = speed || 0;
          laluceMode = 100;
          laluceSpeed = speed || 0;
          cobMode = 101;
          cobSpeed = speed || 0;
          break;
        }
      case FADE_OUT:
        {
          slimParMode = 95;
          slimParSpeed = speed || 0;
          yeesiteMode = 149;
          yeesiteStrobeSpeed = speed || 0;
          laluceMode = 199;
          laluceSpeed = speed || 0;
          cobMode = 101;
          cobSpeed = speed || 0;
          break;
        }
      case NO_EFFECT:
        {
          slimParMode = 0;
          slimParSpeed = 0;
          yeesiteMode = 0;
          yeesiteStrobeSpeed = 0;
          laluceMode = 0;
          laluceSpeed = 0;
          cobMode = 0;
          cobSpeed = 0;
          break;
        }
      case DANCE_PARTY:
        {
          const dancePartyFast = 253;
          slimParMode = 223;
          slimParSpeed = dancePartyFast;
          yeesiteMode = 251;
          yeesiteStrobeSpeed = dancePartyFast;
          laluceMode = 251;
          laluceSpeed = dancePartyFast;
          cobMode = 251;
          cobSpeed = dancePartyFast;
          break;
        }
      case LEAVE_EFFECT:
        {
          // If slimParMode is in the range [0, 31] and slimParSpeed is somewhere in [16, 255],
          // the light will go to strobe mode. Here we leave slimParSpeed *and* slimParMode as they are
          // so the effect stays however it was before.
          slimParSpeed = -1;
          slimParMode = -1;

          // Documentation for yeesite and laluce are not as good as slim par, but I am assuming
          // it will behave similar to slim par in this case
          yeesiteStrobeSpeed = -1;
          yeesiteMode = -1;
          laluceSpeed = -1;
          laluceMode = -1;
          cobMode = -1;
          cobSpeed = -1;
          break;
        }
      default:
        break;
    }
  });
  return {
    slimParSpeed,
    slimParMode,
    yeesiteMode,
    yeesiteStrobeSpeed,
    laluceMode,
    laluceSpeed,
    cobMode,
    cobSpeed,
    cobStrobeSpeed: 0,
    // We do not use a strobe effect
    laluceHoppingMode: 0,
    // hopping mode is never used
    slimParMacro: -1,
    // Slim Par macro should never be set
    whiteChannel: -1,
    // New lights have white channel that we do not use
    amberChannel: -1,
    // New Cob lights have amber channel that we do not use
    chauvetMode: 210 // Only ever use RGB Color Mix mode for chauvet colorstrip mini
  };
}

/**
 * All light styles that we have defined and can be used to update the lights.
 * lighting for special effects will be an array of these light styles that run
 * in order to create amazing lighting effects
 */
const lightStyles = {
  [LIGHT_STYLE_IDS.NONE]: {
    id: LIGHT_STYLE_IDS.NONE,
    channels: getChannels({
      brightness: 0
    })
  },
  [LIGHT_STYLE_IDS.NO_CHANGE]: {
    id: LIGHT_STYLE_IDS.NO_CHANGE,
    channels: getPassiveChannels()
  },
  [LIGHT_STYLE_IDS.AMBIANCE_BLUE]: {
    id: LIGHT_STYLE_IDS.AMBIANCE_BLUE,
    channels: getChannels({
      blue: 255,
      green: 255
    })
  },
  [LIGHT_STYLE_IDS.AMBIANCE_BLUE_STEALTH]: {
    id: LIGHT_STYLE_IDS.AMBIANCE_BLUE_STEALTH,
    channels: getChannels({
      blue: 255,
      brightness: 150
    })
  },
  [LIGHT_STYLE_IDS.AMBIANCE_RED]: {
    id: LIGHT_STYLE_IDS.AMBIANCE_RED,
    channels: getChannels({
      red: 255
    })
  },
  [LIGHT_STYLE_IDS.AMBIANCE_WHITE]: {
    id: LIGHT_STYLE_IDS.AMBIANCE_WHITE,
    channels: getChannels({
      red: 255,
      green: 255,
      blue: 255
    })
  },
  [LIGHT_STYLE_IDS.RED]: {
    id: LIGHT_STYLE_IDS.RED,
    channels: getChannels({
      red: 255
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.RED_LOW]: {
    id: LIGHT_STYLE_IDS.RED_LOW,
    channels: getChannels({
      red: 255,
      brightness: 10
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.GREEN]: {
    id: LIGHT_STYLE_IDS.GREEN,
    channels: getChannels({
      green: 255
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.GREEN_LOW]: {
    id: LIGHT_STYLE_IDS.GREEN_LOW,
    channels: getChannels({
      green: 255,
      brightness: 10
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.BLUE]: {
    id: LIGHT_STYLE_IDS.BLUE,
    channels: getChannels({
      blue: 255
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.BLUE_LOW]: {
    id: LIGHT_STYLE_IDS.BLUE_LOW,
    channels: getChannels({
      blue: 255,
      brightness: 0
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.INFINID_ORANGE]: {
    id: LIGHT_STYLE_IDS.INFINID_ORANGE,
    channels: getChannels({
      red: 255,
      green: 194,
      blue: 14
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.WHITE]: {
    id: LIGHT_STYLE_IDS.WHITE,
    channels: getChannels({
      red: 255,
      green: 255,
      blue: 255
    }, [LEAVE_EFFECT])
  },
  [LIGHT_STYLE_IDS.ADD_RED]: {
    id: LIGHT_STYLE_IDS.ADD_RED,
    channels: getPassiveChannels({
      red: 255
    })
  },
  [LIGHT_STYLE_IDS.ADD_GREEN]: {
    id: LIGHT_STYLE_IDS.ADD_GREEN,
    channels: getPassiveChannels({
      green: 255
    })
  },
  [LIGHT_STYLE_IDS.ADD_BLUE]: {
    id: LIGHT_STYLE_IDS.ADD_BLUE,
    channels: getPassiveChannels({
      blue: 255
    })
  },
  [LIGHT_STYLE_IDS.SUB_RED]: {
    id: LIGHT_STYLE_IDS.SUB_RED,
    channels: getPassiveChannels({
      red: 0
    })
  },
  [LIGHT_STYLE_IDS.SUB_GREEN]: {
    id: LIGHT_STYLE_IDS.SUB_GREEN,
    channels: getPassiveChannels({
      green: 0
    })
  },
  [LIGHT_STYLE_IDS.SUB_BLUE]: {
    id: LIGHT_STYLE_IDS.SUB_BLUE,
    channels: getPassiveChannels({
      blue: 0
    })
  },
  [LIGHT_STYLE_IDS.PULSE]: {
    id: LIGHT_STYLE_IDS.PULSE,
    channels: getPassiveChannels({
      speed: 200,
      brightness: 255
    }, [PULSE])
  },
  [LIGHT_STYLE_IDS.PULSE_MEDIUM]: {
    id: LIGHT_STYLE_IDS.PULSE_MEDIUM,
    channels: getPassiveChannels({
      speed: 225,
      brightness: 255
    }, [PULSE])
  },
  [LIGHT_STYLE_IDS.PULSE_FAST]: {
    id: LIGHT_STYLE_IDS.PULSE_FAST,
    channels: getPassiveChannels({
      speed: FAST_EFFECT,
      brightness: 255
    }, [PULSE])
  },
  [LIGHT_STYLE_IDS.FADE_IN]: {
    id: LIGHT_STYLE_IDS.FADE_IN,
    channels: getPassiveChannels({
      speed: 200,
      brightness: 255
    }, [FADE_IN])
  },
  [LIGHT_STYLE_IDS.FADE_IN_SLOW]: {
    id: LIGHT_STYLE_IDS.FADE_IN_SLOW,
    channels: getPassiveChannels({
      speed: 140,
      brightness: 255
    }, [FADE_IN])
  },
  [LIGHT_STYLE_IDS.FADE_IN_MEDIUM]: {
    id: LIGHT_STYLE_IDS.FADE_IN_MEDIUM,
    channels: getPassiveChannels({
      speed: 225,
      brightness: 255
    }, [FADE_IN])
  },
  [LIGHT_STYLE_IDS.FADE_IN_FAST]: {
    id: LIGHT_STYLE_IDS.FADE_IN_FAST,
    channels: getPassiveChannels({
      speed: FAST_EFFECT,
      brightness: 255
    }, [FADE_IN])
  },
  [LIGHT_STYLE_IDS.FADE_OUT_SLOW]: {
    id: LIGHT_STYLE_IDS.FADE_OUT_SLOW,
    channels: getPassiveChannels({
      speed: 150,
      brightness: 255
    }, [FADE_OUT])
  },
  [LIGHT_STYLE_IDS.FADE_OUT]: {
    id: LIGHT_STYLE_IDS.FADE_OUT,
    channels: getPassiveChannels({
      speed: 200,
      brightness: 255
    }, [FADE_OUT])
  },
  [LIGHT_STYLE_IDS.FADE_OUT_MEDIUM]: {
    id: LIGHT_STYLE_IDS.FADE_OUT_MEDIUM,
    channels: getPassiveChannels({
      speed: 225,
      brightness: 255
    }, [FADE_OUT])
  },
  [LIGHT_STYLE_IDS.FADE_OUT_FAST]: {
    id: LIGHT_STYLE_IDS.FADE_OUT_FAST,
    channels: getPassiveChannels({
      speed: FAST_EFFECT,
      brightness: 255
    }, [FADE_OUT])
  },
  [LIGHT_STYLE_IDS.NO_EFFECT]: {
    id: LIGHT_STYLE_IDS.NO_EFFECT,
    channels: getPassiveChannels(null, [NO_EFFECT])
  },
  [LIGHT_STYLE_IDS.NO_EFFECT_LOW]: {
    id: LIGHT_STYLE_IDS.NO_EFFECT_LOW,
    channels: getPassiveChannels({
      brightness: 75
    }, [NO_EFFECT])
  },
  [LIGHT_STYLE_IDS.NO_EFFECT_VERY_LOW]: {
    id: LIGHT_STYLE_IDS.NO_EFFECT_VERY_LOW,
    channels: getPassiveChannels({
      brightness: 10
    }, [NO_EFFECT])
  },
  [LIGHT_STYLE_IDS.BRIGHTNESS_HIGH]: {
    id: LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
    channels: getPassiveChannels({
      brightness: 255
    })
  },
  [LIGHT_STYLE_IDS.BRIGHTNESS_BLIP]: {
    id: LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
    channels: getPassiveChannels({
      brightness: 200
    })
  },
  [LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM]: {
    id: LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
    channels: getPassiveChannels({
      brightness: 150
    })
  },
  [LIGHT_STYLE_IDS.BRIGHTNESS_LOW]: {
    id: LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
    channels: getPassiveChannels({
      brightness: 50
    })
  },
  [LIGHT_STYLE_IDS.BRIGHTNESS_VERY_LOW]: {
    id: LIGHT_STYLE_IDS.BRIGHTNESS_VERY_LOW,
    channels: getPassiveChannels({
      brightness: 10
    })
  },
  [LIGHT_STYLE_IDS.PASSIVE_RED]: {
    id: LIGHT_STYLE_IDS.PASSIVE_RED,
    channels: getPassiveChannels({
      red: 255,
      blue: 0,
      green: 0,
      brightness: 255
    })
  },
  [LIGHT_STYLE_IDS.DANCE_PARTY]: {
    id: LIGHT_STYLE_IDS.DANCE_PARTY,
    channels: getChannels({
      brightness: 255
    }, [DANCE_PARTY])
  }
};
function getLightStyle(lightStyleId) {
  return lightStyles[lightStyleId];
}